import React from 'react'

import {Toggle} from '@vio/atlas/src/components/designSystem/Toggle'

export const PriceWatchBaseToggle = ({
  isToggleOn,
  handleClick
}: {
  isToggleOn: boolean
  handleClick: (event: React.SyntheticEvent<Element, Event>) => void
}) => {
  return (
    <Toggle
      checked={isToggleOn}
      id="PriceWatchToggle"
      onChange={handleClick}
      dataId="PriceWatchToggle"
    />
  )
}
